import {LABELS} from '../constants/labels'
import type {UnassignedEvent$key} from './__generated__/UnassignedEvent.graphql'
import type {AssignedEventFragment} from './AssignedEvent'
import {AddedAssigneesRendering} from './AssignedEvent'
import {RemovedAssigneesRendering} from './UnassignedEvent'

export type RolledupAssignedEventProps = {
  rollupGroup: Record<string, Array<AssignedEventFragment | UnassignedEvent$key>>
}
export function RolledupAssignedEvent({rollupGroup}: RolledupAssignedEventProps): React.ReactElement {
  const addedEvents = (rollupGroup['AssignedEvent'] as AssignedEventFragment[]) || []
  const removedEvents = (rollupGroup['UnassignedEvent'] as UnassignedEvent$key[]) || []

  return (
    <>
      <AddedAssigneesRendering queryRefs={addedEvents} selfAssigned={false} rollup />
      {addedEvents.length > 0 && removedEvents.length > 0 && ` ${LABELS.timeline.and} `}
      <RemovedAssigneesRendering queryRefs={removedEvents} selfAssigned={false} rollup />
    </>
  )
}
